import __vue_component__$2 from '../Select/Select.vue.js';
import __vue_component__$1 from '../Form/InlineEdit.vue.js';
import __vue_component__ from './MultiSelectRenderer.vue.js';

//
var script = {
  name: 'MultiSelectEditableRenderer',
  components: {
    MultiSelectRenderer: __vue_component__,
    InlineEdit: __vue_component__$1,
    Select: __vue_component__$2
  },
  props: {
    selectedValues: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'right'
    },
    allowedValues: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      options: this.allowedValues
    };
  },

  methods: {
    onSaveRequested(value, callback) {
      try {
        if (Array.isArray(value)) {
          this.$emit('save-requested', value, callback);
        } else {
          callback(new Error('Value should be an array'));
        }
      } catch (error) {
        callback(error);
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/MultiSelectEditableRenderer.vue_rollup-plugin-vue=script.js